import { Spinner } from '@/components/common';
import React from 'react';
import { ActivationCard } from './ActivationCard';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Connecting to activation service...',
}) => (
  <ActivationCard>
    <div className="text-center">
      <Spinner />
      <p className="mt-3 text-muted">{message}</p>
    </div>
  </ActivationCard>
);
